export default "513966e260bb7610.ttf"